<template>
  <v-row>
    <v-col sm="4" lg="3" cols="12" style="padding-bottom: 20px; max-height: 60px">
      <v-text-field
        solo
        :label="$t('search')"
        append-icon="mdi-magnify"
        single-line
        v-model="search"
        :color="colorTheme"
      ></v-text-field>
    </v-col>
    <!-- Por el momento se descartan grupos -->
    <!-- <v-col sm="4" md="3" lg="2" cols="12" style="padding-bottom: 0;">
      <v-select
        :items="optionsGroup"
        solo
        :color="colorTheme"
        v-model="filterByGroup"
        :label="$t('filterVehicles')"
      ></v-select>
    </v-col> -->
    <!-- <v-col sm="4" md="3" lg="2" cols="12" style="padding-bottom: 20px">
      <v-tooltip
        v-model="showTooltip"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            style="width: 100%; margin: 0"
            large
            :color="colorTheme"
            class="white--text"
            v-on:click="consultProgress()"
          >{{ $t("consultProgress").toUpperCase() }}</v-btn>
        </template>
        <span>{{ $t("vehiclesInProg") }}</span>
      </v-tooltip>
    </v-col> -->
    <v-col sm="4" md="3" lg="2" cols="12" class="pb-0">
      <v-btn
        style="width: 100%;"
        v-if="selected.length > 0"
        large
        :color="colorTheme"
        class="white--text regulartText ma-0"
        @click="setUp()"
      >{{ $t("setUp").toUpperCase() }}</v-btn>
    </v-col>
    <v-col lg="12" md="12" sm="12">
      <v-data-table
        v-model="selected"
        :headers="headersVehAT"
        :items="vehiclesAT"
        item-key="MovilId"
        :loading="loadingTableInVehAT"
        :loading-text="$t('loadingTextForTable')"
        show-select
        class="myTableTD elevation-1"
        :items-per-page="5"
        :single-expand="true"
        show-expand
        :expanded.sync="expanded"
        @item-expanded="onExpand"
        :search="search"
        :no-data-text="$t('noResults')"
        :footer-props="{
          'items-per-page-text': $t('rows'),
          'items-per-page-all-text': $t('all')
        }"
        selectable-key="isSelectable"
      >
        <template v-slot:item.Template="{ item }">
          <v-btn
            text
            small
            :disabled="item.Status == statusConfigProg"
            :color="colorTheme"
            v-on:click="openTemplate(item)"
          >{{ item.Template }}</v-btn>
        </template>

        <template v-slot:item.LastConfiguration="{ item }">
          <span>{{ item.LastConfigurationAsText }}</span>
        </template>

        <template v-slot:item.LastTransmission="{ item }">
          <span>{{ item.LastTransmissionAsText }}</span>
        </template>

        <template v-slot:item.IdleTime="{ item }">
          <span>{{ item.IdleTimeAsText }}</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            text
            small
            :disabled="item.Status == statusConfigProg"
            :color="colorTheme"
            v-on:click="verifyConfig(item)"
          >{{ $t("verifyConfig").toUpperCase() }}</v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="text-start regulartText">
            <p class="mb-0">
              {{ $t("address").toUpperCase() }}:
              <span
                class="pl-1"
                :style="'color:' + colorTheme + ';cursor:pointer;'"
                v-on:click="openMap(item)"
              >{{ address }}</span>
            </p>
          </td>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="mdi-alert"
        >{{ $t("noResults") }} : "{{ search }}".</v-alert>
        <template v-slot:footer.page-text="items">
          {{ items.pageStart }} - {{ items.pageStop }}
          {{ $t("of").toLowerCase() }} {{ items.itemsLength }}
        </template>
      </v-data-table>
    </v-col>

    <!-- Dialog de mapa -->
     <v-dialog
        v-model="dialogVehAT"
        width="900"
        eager
        :fullscreen="$vuetify.breakpoint.mdAndDown"
        overlay-opacity="0"
      >
        <v-card>
          <v-toolbar id="myMapaHeader" color="#D3D3D3" flat dense>
          <v-toolbar-title class="subtitle3Text">{{ $t("map").toUpperCase() }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn x-small height="50" text @click="dialogVehAT = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
         <!-- para mobile/tablet -->
          <v-card-text class="pa-0" v-if="$vuetify.breakpoint.mdAndDown" style="color:black;position:relative;width:100vw;height:100vh;">
            <!-- se usa el calculo restando el 100 de la altura menos los 48px de la toolbar -->
            <div  id="mapVehiclesAT" style="height: calc(100vh - 48px);"></div>
          </v-card-text>
        <!-- para escritorio -->
        <v-card-text class="pa-0" style="color:black;" v-else>
            <div  id="mapVehiclesAT" style="height: 500px;"></div>
          </v-card-text>
        </v-card>
      </v-dialog> 
      <!-- Ejemplo de un echo server (lo que envias, te lo regresa) -->
    <!-- <v-col cols="12">
      <v-card-title>ECHO SERVER</v-card-title>
    </v-col>
    <v-col
      sm="4"
      lg="3"
      cols="12"
      style="padding-bottom: 20px;"
    >
    <v-card class="mx-auto text-start" width="450" height="300" outlined style="overflow-y: scroll;">
        <v-card-title>RECIBIDO</v-card-title>
        <v-card-text style="color: black;">
          <div v-for="(item, index) in received" :key="index" >
          {{ item }}
          <v-divider></v-divider>
          </div>
        </v-card-text>
      </v-card>
      <v-text-field
        class="pt-4"
        outlined
        label="Escriba aquí..."
        @keydown.enter="callWS()"
        v-model="firstTextField"
      ></v-text-field>
    </v-col>
    <v-col sm="4" lg="3" cols="12" style="padding-bottom: 20px">
      <v-card class="mx-auto text-start" width="450" height="300" outlined style="overflow-y: scroll;">
        <v-card-title>LOGS</v-card-title>
        <v-card-text style="color: black;">
          <div v-for="(item, index) in logs" :key="index" >
          {{ item }}
          </div>
        </v-card-text>
      </v-card>
    </v-col> -->
    <!-- Fin de ejemplo -->
  </v-row>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
export default {
  name: "vehiclesAT",
  data() {
    return {
      search: "",
      singleSelect: false,
      selected: [],
      expanded: [],
      filterByGroup: null,
      address: "",
      statusConfigProg: i18n.t("configProcess"),
      map:null,
      dialogVehAT: false,
      showMap: false,
      firstTextField: "",
    };
  },
  created() {
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("setPageHeader", [
      this.$t("parametersConfig").toUpperCase(),
      "",
      "",
      "",
      true
    ]);
  },
  mounted() {
    this.$store.dispatch("catalogVehAT");
  },
  computed: {
    ...mapState([
      "colorTheme",
      "vehiclesAT",
      "optionsGroup",
      "loadingTableInVehAT",
      "logs",
      "received"
    ]),
    // showTooltip() {
    //   return true ? this.$store.state.notiNumber > 0 : false
    // },
    //se necesita tener headers en computed por el filtro de grupos
    headersVehAT() {
      return [
        // {
        //   text: i18n.t("group").toUpperCase(),
        //   value: "Group",
        //   align: "center",
        //   filter: this.groupFilter
        // },
        {
          text: i18n.t("movilId").toUpperCase(),
          value: "MovilId",
          align: "center"
        },
        {
          text: i18n.t("nick").toUpperCase(),
          value: "Nick",
          align: "center"
        },
        {
          text: i18n.t("config").toUpperCase(),
          value: "Template",
          align: "center"
        },
        {
          text: i18n.t("lastConfig").toUpperCase(),
          value: "LastConfiguration",
          align: "center"
        },
        {
          text: i18n.t("statusT").toUpperCase(),
          value: "Status",
          align: "center"
        },
        {
          text: i18n.t("lastTransmission").toUpperCase(),
          value: "LastTransmission",
          align: "center"
        },
        {
          text: i18n.t("idleTime").toUpperCase(),
          value: "IdleTime",
          align: "center"
        },
        {
          text: i18n.t("actions").toUpperCase(),
          value: "actions",
          align: "center",
          sortable: false
        },
        { text: "", value: "data-table-expand" }
      ];
    }
  },
  methods: {
    showAssignView(item) {
      console.log(item);
      //this.$store.dispatch("assignTemplate", item);
      this.$router.push({ name: "assignTemplate" });
      this.$store.commit("setPageHeader", [
        this.$t("configTemplates").toUpperCase(),
        this.$t("templateAssignment").toUpperCase(),
        "",
        "",
        true
      ]);
    },
    groupFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.filterByGroup) {
        return true;
      }
      // Check if the current loop value (The Group value)
      // equals to the selected value at the <v-select>.
      return value === this.filterByGroup;
    },
    verifyConfig(item) {
      this.$store.commit("selectedVehAT", item);
      localStorage.setItem("selectedVehAT", JSON.stringify(item));
      this.$router.push({ name: "verifyConfiguration" });
    },
    openTemplate(item) {
      this.$store.dispatch("getTemplateContent", item);
    },
    onExpand({ item, value }) {
      //se asigna texto mientras se obtiene la direccion por medio de geocod inversa
      this.address = i18n.t("loadingAdress");
      //si se uso el expanded para abrir procedemos a obtener la direccion por medio de geocod inversa
      if (value) {
        // var geocoder = new google.maps.Geocoder();
        // var latlng = {
        //   lat: item.Location.Lat,
        //   lng: item.Location.Lon
        // };
        // var vm = this;
        // geocoder.geocode({ location: latlng }, function(results, status) {
        //   if (status === "OK") {
        //     if (results[0]) {
        //       var ubicacion = results[0].formatted_address;
        //       vm.address = ubicacion;
        //     } else {
        //       vm.address = i18n.t("noResultsFound");
        //     }
        //   } else {
        //     vm.address = i18n.t("geoFailed") + " " + status;
        //   }
        // });
      }
    },
    openMap(item) {
      this.dialogVehAT = true;
      var latlng = {
        lat: item.Location.Lat,
        lng: item.Location.Lon
      };
      this.map = new google.maps.Map(document.getElementById("mapVehiclesAT"), {
        zoom: 18,
        center: latlng
      });

      let contentString =
        '<div style="max-width: 340px;">' +
          `<p class="mb-0"><b class="font-weight-bold">${i18n.t("vehicle")}:</b> ${item.Nick} (${item.MovilId})</p>` +
          `<p class="mb-0"><b class="font-weight-bold">${i18n.t("address")}:</b> ${this.address}</p>` +
          `<p class="mb-0"><b class="font-weight-bold">${i18n.t("lastTransmission")}:</b> ${item.LastTransmissionAsText}</p>` +
        "</div>";

      var infowindow = new google.maps.InfoWindow({
        content: contentString
      });

      var marker = new google.maps.Marker({
        position: latlng,
        map: this.map
      });
      infowindow.open(this.map, marker);
      marker.addListener("click", function() {
        infowindow.open(this.map, marker);
      });
    },
    closeMap() {
      this.dialogVehAT = false;
    },
    setUp() {
      //mostrar version light de plantillas (sin checkbox y en acciones solo Asignar)
      this.$store.commit("fullVersion", false);
      this.$store.commit("showVehiclesAT", false);
    },
    consultProgress() {
      this.$router.push({ name: "configurationProgress" });
    },
    //al presionar enter, se envia el contenido del text field
    // callWS(){
    //   this.$store.state.client.send('/topic/test', {"content-type":"text/plain"}, this.firstTextField);
    //   this.firstTextField = "";
    //  }
  }
};
</script>

<style scoped>
#myMapaHeader {
  border-radius: 0;
}
</style>